const types = {
  SET_LOGGED_IN: 'SET_LOGGED_IN',
  SET_USERNAME: 'SET_USERNAME',
  SET_NOME: 'SET_NOME',
  SET_VINCULO: 'SET_VINCULO',
  SET_ADMINISTRADOR: 'SET_ADMINISTRADOR',
  SET_USUARIO_PROEX: 'SET_USUARIO_PROEX',
  SET_PERMISSAO_CRIAR_PROJETO_EXTENSAO: 'SET_PERMISSAO_CRIAR_PROJETO_EXTENSAO',
  UNSET_LOGGED_IN: 'UNSET_LOGGED_IN',
  UNSET_USERNAME: 'UNSET_USERNAME',
  UNSET_NOME: 'UNSET_NOME',
  UNSET_VINCULO: 'UNSET_VINCULO',
  UNSET_ADMINISTRADOR: 'UNSET_ADMINISTRADOR',
  UNSET_USUARIO_PROEX: 'UNSET_USUARIO_PROEX',
  UNSET_PERMISSAO_CRIAR_PROJETO_EXTENSAO: 'UNSET_PERMISSAO_CRIAR_PROJETO_EXTENSAO',
  SHOW_GLOBAL_LOADING: 'ui/SHOW_GLOBAL_LOADING',
  HIDE_GLOBAL_LOADING: 'ui/HIDE_GLOBAL_LOADING',
  SHOW_SNACKBAR: 'ui/SHOW_SNACKBAR',
  HIDE_SNACKBAR: 'ui/HIDE_SNACKBAR'
}

export default types



// WEBPACK FOOTER //
// ./src/vuex/auth/mutations-types.js